// reducers.js
import {
    FETCH_DEMO_CATALOG_REQUEST,
    FETCH_DEMO_CATALOG_SUCCESS,
    FETCH_DEMO_CATALOG_FAILURE,
    FETCH_NARRATIVE_DETAILS_REQUEST,
    FETCH_NARRATIVE_DETAILS_SUCCESS,
    FETCH_NARRATIVE_DETAILS_FAILURE
} from '../../../Constants/actionTypes';

const initialState = {
    demoCatalog: {
        isLoading: false,
        data: null,
        error: null
    },
    narrativeDetails: {
        isLoading: false,
        data: null,
        error: null
    }
};

const rootReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_DEMO_CATALOG_REQUEST:
            return {
                ...state,
                demoCatalog: {
                    ...state.demoCatalog,
                    isLoading: true,
                    error: null
                }
            };
        case FETCH_DEMO_CATALOG_SUCCESS:
            return {
                ...state,
                demoCatalog: {
                    ...state.demoCatalog,
                    isLoading: false,
                    data: action.payload,
                    error: null
                }
            };
        case FETCH_DEMO_CATALOG_FAILURE:
            return {
                ...state,
                demoCatalog: {
                    ...state.demoCatalog,
                    isLoading: false,
                    error: action.payload
                }
            };
        case FETCH_NARRATIVE_DETAILS_REQUEST:
            return {
                ...state,
                narrativeDetails: {
                    ...state.narrativeDetails,
                    isLoading: true,
                    error: null
                }
            };
        case FETCH_NARRATIVE_DETAILS_SUCCESS:
            return {
                ...state,
                narrativeDetails: {
                    ...state.narrativeDetails,
                    isLoading: false,
                    data: action.payload,
                    error: null
                }
            };
        case FETCH_NARRATIVE_DETAILS_FAILURE:
            return {
                ...state,
                narrativeDetails: {
                    ...state.narrativeDetails,
                    isLoading: false,
                    error: action.payload
                }
            };
        default:
            return state;
    }
};

export default rootReducer;
